<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.currency_rates_api_settings.form.api_base_uri')"
            :is-required="true"
            :error="errorsData.api_base_uri"
            :hint="__('settings.currency_rates_api_settings.form.api_base_uri_hint')"
        >
            <DInput
                id="api_base_uri"
                v-model="form.api_base_uri"
                placeholder="https://api.example.org/rest/"
                :is-valid="isFormFieldValid('api_base_uri')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.currency_rates_api_settings.form.api_key')"
            :is-required="currencyRatesApiSettings === null"
            :error="errorsData.api_key"
            :hint="__('settings.currency_rates_api_settings.form.api_key_hint')"
        >
            <DInput
                id="api_key"
                v-model="form.api_key"
                :placeholder="__('settings.currency_rates_api_settings.form.api_key')"
                :is-valid="isFormFieldValid('api_key')"
                maxlength="255"
            />
            <DRow>
                <DCol sm="2" />
                <DCol sm="3">
                    <div
                        v-if="connectionStatus === 'succeeded'"
                        style="color: green;"
                    >
                        {{ __('settings.currency_rates_api_settings.connection_succeeded') }}
                    </div>
                    <div
                        v-if="connectionStatus === 'failed'"
                        style="color: red;"
                    >
                        {{ __('settings.currency_rates_api_settings.connection_failed') }}
                    </div>
                </DCol>
                <DCol
                    sm="3"
                    style="text-align: right; padding-bottom: 12px;"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.currency_rates_api_settings.check_connection')"
                        :disabled="isInLoadingState"
                        @click="checkConnection"
                    />
                </DCol>
            </DRow>
        </DFormRow>
        <DFormControls
            v-show="credentialsValid"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'CurrencyRatesApiSettingsForm',
    components: { DConnectionErrorModal },
    props: {
        currencyRatesApiSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                api_base_uri: this.currencyRatesApiSettings?.api_base_uri ?? null,
                api_key: this.currencyRatesApiSettings?.api_key ?? null
            }),
            connectionStatus: '',
            credentialsValid: false,
            connectionException: null,
            errorsData: this.errors
        }
    },
    watch: {
        form: {
            handler: function () {
                this.connectionStatus = ''
                this.credentialsValid = false
            },
            deep: true
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.currency-rates-api-settings.check', this.form))
                .then(function () {
                    self.connectionStatus = 'succeeded'
                    self.credentialsValid = true
                })
                .catch(function (error) {
                    self.connectionStatus = 'failed'
                    self.credentialsValid = false

                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error?.response.data.exception
                    }
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
        }
    }
}
</script>
